import { IInstaller } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/MapsLocator/MapsLocator';

export const partnersFactory = (partnersNodes: any): IInstaller[] => {
    return partnersNodes
        ?.filter((p: any) => p.fields.Latitude != '0' && p.Longitude != '0')
        ?.map(
            (partnersNode: any) =>
                ({
                    id: partnersNode.id,
                    name: transformSpecialChar(partnersNode.AccountName),
                    phone: partnersNode.Phone,
                    email:
                        partnersNode.Email == 'null'
                            ? null
                            : partnersNode.Email,
                    street: partnersNode.ShippingStreet,
                    city: partnersNode.ShippingCity,
                    zipcode: partnersNode.ShippingPostalCode,
                    state: partnersNode.ShippingState,
                    country: partnersNode.ShippingCountry,
                    lng: parseFloat(partnersNode.fields.Longitude),
                    lat: parseFloat(partnersNode.fields.Latitude),
                    website: formatWebUrl(partnersNode.Website),
                } as IInstaller)
        );
};

const formatWebUrl = (url: string): string | null | undefined => {
    const patternHttp = /^((http):\/\/)/;
    const patternHttps = /^((https):\/\/)/;
    let formatedUrl: string | null = url;

    if (formatedUrl && formatedUrl != 'null') {
        if (patternHttp.test(formatedUrl)) {
            formatedUrl = 'https:' + formatedUrl.substring(5);
        }

        if (!patternHttps.test(formatedUrl)) {
            formatedUrl = 'https://' + formatedUrl;
        }

        if (formatedUrl.includes('@')) {
            formatedUrl = null;
        }
    } else {
        formatedUrl = null;
    }
    return formatedUrl;
};

const transformSpecialChar = (text: string): string => {
    return text
        .replace(/&amp;/g, '&')
        .replace(/&#x27;/g, "'")
        .replace(/&#x60;/g, '`');
    return text;
};
